import { render, staticRenderFns } from "./gl-global-slot-switcher.vue?vue&type=template&id=5ef28f63"
import script from "./gl-global-slot-switcher.vue?vue&type=script&lang=js"
export * from "./gl-global-slot-switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports